module.exports = __webpack_public_path__ + "img/choice.3b0e79f5.png";